import format from 'date-fns/format'

import { getCurrentLocale } from '@probatix/common/translations'

export const formatDateLocale = (date: Date, dateFormat: string) => {
  const locale = getCurrentLocale()

  return format(date, dateFormat, { locale })
}
